<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Hub InScan</strong>           
          </div>    
          <div class="box">
             <form @submit.prevent="validateForm2('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <b-form-group label="Shipment Id" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipmentid') }" placeholder="Enter Shipment Id ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                   </b-form-group>          
                </b-col> 
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button>               
                </b-col>
              </b-row>  
            </form>
            <!-- <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                <b-form-group label="Shipment Id"  :label-cols="3" >
                   <b-form-input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipmentid') }" placeholder="Enter Shipment Id ">
                   </b-form-input>
                   <span v-show="errors.has('form-1.shipmentid')" class="help is-danger">{{ errors.first('form-1.shipmentid') }}</span>              
                  </b-form-group> 
                </b-col>
                <b-col md="6" >
                <b-button class="mr-2" type="submit" size="md" variant="primary">Show</b-button>
                <b-button type="button" @click="clear" size="md" variant="danger">Clear</b-button>
                </b-col>
              </b-row>  
           </form> -->
          </div>
         
           <b-table show-empty stacked="md" :busy="isBusy" :items="ConsignmentMasterGetdata"  :fields="fields"   :outlined="outlined"  >

              <template slot="actions" slot-scope="row">
                 <input class="shipmentscheckbox" type="checkbox"  v-bind:value="row.item"  v-model='handovership' @change='updateCheckall()'/>
              </template> 
               <template slot="productinfo" slot-scope="row">
                 {{ (row.item.productinfo)?row.item.productinfo:'-' }}
               </template> 
                <template slot="returnreason" slot-scope="row">
                 {{ (row.item.returnreason)?row.item.returnreason:'-' }}
               </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>             
            </b-table>
             <b-row>
              <b-col md="6" >  
                  <span id="checkall" style="display:none;">

                  <input type='checkbox' @click='checkAll()' v-model='isCheckAll' > Check All
                  <input type='button' @click='scanShipment()' value='Scan' size="md" class="btn mr-4 btn-primary btn-md" >
                </span>
              </b-col>
          </b-row>  

        </b-card>
      </b-col>    
  </b-row>
</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      isBusy: false,
      customer: {},
      outlined:true,
      data: [],    
      selectedlang: "",
      isCheckAll: false,
      handovership: [],
       fields: [
          { key: 'actions', label: 'Sr .no' },
          { key: 'shippingid', label: 'shippingid' },
          { key: 'productid', label: 'product id'},
          { key: 'productname', label: 'Product Name'},
          { key: 'productinfo', label: 'Info'},           
          { key: 'productquantity', label: 'Quantity' },    
          { key: 'productstatus', label: 'Status' },          
          { key: 'acceptedproductqty', label: 'acceptedproduct' },        
          { key: 'returnproductqty', label: 'returnproduct' },          
          { key: 'returnreason', label: 'reason' }       
        
        ],
      ConsignmentMasterGetdata: [],
       hubid:'',
       hubexecutiveid:'',
       latlong:'',
       scantype:'inscan'
    }
  },
  created: function () {
    var userdata = localStorage.getItem('userData');
    var userInfo = JSON.parse(userdata);   
    this.hubid=userInfo.pickuplocationmasterid.toString();
    this.hubexecutiveid=userInfo.sysusermasterid;
    this.latlong=userInfo.pickuplonglat;

  },
  methods: {
    checkAll: function(){
      this.isCheckAll = !this.isCheckAll;
      this.handovership = [];
      // console.log(this.ConsignmentMasterGetdata);
      if(this.isCheckAll){ // Check all
        for (var key in this.ConsignmentMasterGetdata) {
          this.handovership.push(this.ConsignmentMasterGetdata[key]);
        }
      }
    },
    updateCheckall: function(){
      if(this.handovership.length == this.ConsignmentMasterGetdata.length){
         this.isCheckAll = true;
      }else{
         this.isCheckAll = false;
      }
    },
    scanShipment: function(){
      this.selectedlang = "";
      // Read Checked checkboxes value      
      if(this.ConsignmentMasterGetdata.length==this.handovership.length){
       var shipmentid = this.customer.shipmentid
          var searchvaluesarr = shipmentid.trim();
          const customerGetAllobj = {
            hubid:this.hubid,
            shippingid: searchvaluesarr,
            hubexecutiveid:this.hubexecutiveid,
            scantype:this.scantype,
            latlong:this.latlong
          }
          // console.log('--------scan---------');
          // console.log(customerGetAllobj);
          // console.log('--------scan---------');
      
          this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster/hubInscanShipment`, customerGetAllobj)
            .then((result) => {
            // console.log(result.body);
             if (result.body.returnmsg === 'Successful') {
                Utils.notify('Successfully scan shipment', 'success')
                this.ConsignmentMasterGetdata = [];
                this.handovership = [];
                this.isCheckAll = false;
                var checkall = document.getElementById("checkall");
                  checkall.style.display = "none";
                this.customer = {};
                this.$router.push('consignmenthubinscan')
              } else {
                  Utils.notify(result.body.returnmsg, 'error')
              }
           })
            .catch((ex) => {
              console.log('error', ex)
            })

      }else{
        Utils.notify('Please select all product','error')

      }
    },
    validateForm2(scope) {
      var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         var shipmentidget = this.customer.shipmentid
          const Getobj = {
            shippingid: `${shipmentidget}`
          }
          this.isBusy = true;
          // console.log('Getobj', Getobj)
          this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster/GetRTOShipmentProductsList`, Getobj)
            .then((result) => {
            this.ConsignmentMasterGetdata= [];

              if (result.body.returnmsg === "Successful") {
              var checkall = document.getElementById("checkall");
                  checkall.style.display = "block";
                  
                this.ConsignmentMasterGetdata = result.body.returnvalue;              
                this.isBusy = !this.isBusy;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              } else {
                var checkall = document.getElementById("checkall");
                  checkall.style.display = "none";
                //alert('Result not found')
                this.ConsignmentMasterGetdata = [];
                this.isBusy = !this.isBusy;
                this.handovership = [];
                this.isCheckAll = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
        }
      })
    },
    validateForm(scope) {
      var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var shipmentid = this.customer.shipmentid
          var searchvaluesarr = shipmentid.trim();
          const customerGetAllobj = {
            shippingid: searchvaluesarr
          }
        // console.log(customerGetAllobj);
          this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster/GetRTOShipmentProductsList`, customerGetAllobj)
            .then((result) => {
            // console.log(result.body);
            
            })
            .catch((ex) => {
              console.log('error', ex)
            })
        }
      })
    },
    
    clear: function() {
      this.ConsignmentMasterGetdata = [];
      this.customer = {}
      this.errors.clear('form-1');
      var checkall = document.getElementById("checkall");
                  checkall.style.display = "none";
      this.handovership = [];
      this.isCheckAll = false;            
    }
  }
}
</script>